import { useMemo } from "react"
import type { ReactElement, ReactNode } from "react"
import { connect } from "react-redux"
import { matchPath } from "react-router-dom"
import { SpinnerContainer } from ".."
import { useIsRendered } from "../../../hooks"
import type { AppState, ExcludedCall, LoadingState, SectionLoadingState } from "../../../redux"

export interface ILoadingContainerOwnProps {
  sections?: string[]
  isLoading?: boolean
  children?: ReactNode
  excludedCalls?: ExcludedCall[]
}

export interface ILoadingContainerStateProps {
  loadingState: LoadingState
}

function LoadingContainerView(props: ILoadingContainerOwnProps & ILoadingContainerStateProps): ReactElement {
  const { children, loadingState, sections, isLoading, excludedCalls } = props
  const isRendered: boolean = useIsRendered()
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const computedLoading: boolean = useMemo<boolean>(() => {
    if (isLoading !== undefined) return isLoading
    if (sections) {
      return (
        sections.filter((section: string) => {
          const state: SectionLoadingState | undefined = loadingState[section]

          return (
            state?.loading &&
            !excludedCalls?.find((call) => {
              return (
                call.method === state?.method &&
                matchPath(state?.url || "", {
                  path: call.url,
                  exact: true,
                  strict: false
                })
              )
            })
          )
        }).length > 0
      )
    }
    return false
  }, [loadingState, isLoading, excludedCalls])

  if (computedLoading) {
    return <SpinnerContainer />
  }
  return <>{isRendered && children}</>
}

function mapStateToProps(state: AppState, ownProps: ILoadingContainerOwnProps) {
  return {
    children: ownProps.children,
    loadingState: state.http.state
  }
}

export const LoadingContainer = connect(mapStateToProps)(LoadingContainerView)
